<div class="">
    <div class="sidebar" data-color="azure" data-background-color="azure" data-image="./assets/img/medicoVector.jpg">
        <app-sidebar-cmp></app-sidebar-cmp>
        <div class="sidebar-background" style="background-image: url(assets/img/medicoVector.jpg)"></div>
    </div>
 
 
    <div class="main-panel">
      <!--   <app-header></app-header> -->
        <app-navbar-cmp></app-navbar-cmp>
        <br/> <br/>
        <router-outlet></router-outlet>
        <app-footer-cmp></app-footer-cmp>
    </div>
</div>